export default __webpack_public_path__ + "static/media/HHSmall.fb19ae63.mp3";